// Custom Quantity Selector Functionality
window.attachCustomQuantitySelectorFunctionality = function(){
    console.log('re-attach after variant change...');
    const customQuantitySelectorAll = document.querySelectorAll('.quantity_wrapper_grid');
    if(customQuantitySelectorAll.length > 0) {
        customQuantitySelectorAll.forEach(customQuantitySelectorWrapper => {
            const allOptions = customQuantitySelectorWrapper.querySelectorAll('.option');
            if(allOptions.length > 0) {
                allOptions.forEach(option => {
                    option.addEventListener('click', () => {
                        allOptions.forEach(_option => {
                            _option.classList.remove('selected');
                        });
                        option.classList.add('selected');
                        updateClosestQuantityInput(option);
                    });
                })
            }
        })
    }
}
window.attachCustomQuantitySelectorFunctionality();

function updateClosestQuantityInput(option) {
    const closestMainProductWrapper = option.closest('.product__info-wrapper');
    if(closestMainProductWrapper) {
        const main_quantity_wrapper = closestMainProductWrapper.querySelector('.product-quantity__wrap');
        if(main_quantity_wrapper){
            const quantityComponent = main_quantity_wrapper.querySelector('quantity-component');
            const mainQuantityInput = main_quantity_wrapper.querySelector('.quantity__input[name="quantity"]');
            if(quantityComponent && mainQuantityInput) {
                mainQuantityInput.value = option.dataset.selectedQuantity;
                mainQuantityInput.dispatchEvent(new Event("input",{bubbles:!0}))
            }
        }
    }
}

// size chart

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".size-chart-trigger").forEach(trigger => {
    const blockId = trigger.dataset.blockId;
    const popup = document.getElementById("size-chart-popup-" + blockId);
    const overlay = popup.querySelector(".size-chart-popup__overlay");
    const closeBtn = popup.querySelector(".size-chart-close");

    trigger.addEventListener("click", () => {
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
    });

    [overlay, closeBtn].forEach(el => {
      el.addEventListener("click", () => {
        popup.classList.remove("active");
        document.body.style.overflow = "";
      });
    });
  });
});
